import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import DashboardLayout from "@/components/DashboardLayout";
import Dashboard from "@/pages/Dashboard";
import Properties from "@/pages/Properties";
import Leases from "@/pages/Leases";
import Applications from "@/pages/Applications";
import Tickets from "@/pages/Tickets";
import RentPayments from "@/pages/RentPayments";
import Accounting from "@/pages/Accounting";
import TaxReturn from "@/pages/TaxReturn";
import PaymentReturn from "@/pages/PaymentReturn";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import DataPrivacy from "@/pages/DataPrivacy";
import Billing from "@/pages/Billing";
import Documents from "@/pages/Documents";
import CookieBanner from "@/components/CookieBanner";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/confidentialite" element={<PrivacyPolicy />} />
      <Route path="/payment/success" element={<PaymentReturn />} />
      <Route path="/payment/cancel" element={<PaymentReturn />} />
      <Route
        path="/app"
        element={
          <Protected>
            <DashboardLayout />
          </Protected>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="biens" element={<Properties />} />
        <Route path="baux" element={<Leases />} />
        <Route path="candidatures" element={<Applications />} />
        <Route path="maintenance" element={<Tickets />} />
        <Route path="loyers" element={<RentPayments />} />
        <Route path="comptabilite" element={<Accounting />} />
        <Route path="liasse" element={<TaxReturn />} />
        <Route path="facturation" element={<Billing />} />
        <Route path="documents" element={<Documents />} />
        <Route path="donnees" element={<DataPrivacy />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <CookieBanner />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
